import { AxiosPromise } from 'axios'

const asPromise = <T>(axiosPromise: AxiosPromise): Promise<T> => {
  return new Promise<T>((resolve, reject) => {
    axiosPromise.then((response) => {
      resolve(response.data)
    }, reject)
  })
}

export default asPromise
